module.exports = __webpack_public_path__ + "static/media/Sohne-Buch.7ec29911.otf";